import { FormControl, FormLabel, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import AppTextFieldStyles from "./AppTextField.styles";

const classes = AppTextFieldStyles;

const AppTextField = ({
  label,
  fieldLabel,
  placeholder,
  fullWidth,
  size = "small",
  required = false,
  onKeyPress,
  onChange,
  fieldName,
  fieldId,
  error,
  type,
  removeUpDownIcon = false,
  labelAction,
  value,
}: {
  label?: string;
  fieldLabel?: string;
  placeholder?: string;
  fullWidth?: boolean;
  size?: "small" | "medium";
  required?: boolean;
  onKeyPress: any;
  onChange?: any;
  fieldName: string;
  fieldId: string;
  error?: any;
  type?: any;
  removeUpDownIcon?: boolean;
  labelAction?: React.ReactNode;
  value?: any;
}) => {
  return (
    <FormControl fullWidth={fullWidth}>
      {fieldLabel && (
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0.5}>
          <Stack direction="row">
            <FormLabel sx={{ fontSize: 16, fontWeight: 600, color: "#3E3E3F" }}>
              {fieldLabel}
            </FormLabel>
            {required && <Typography sx={{ color: "#d32f2f", ml: 0.5 }}>*</Typography>}
          </Stack>

          {labelAction && labelAction}
        </Stack>
      )}

      <TextField
        sx={classes.textFieldStyles}
        inputProps={{
          sx: classes.inputPropsStyles,
          required: false,
        }}
        value={value}
        required={required}
        fullWidth={fullWidth}
        size={size}
        label={label}
        placeholder={placeholder}
        onKeyDown={onKeyPress}
        onChange={onChange}
        name={fieldName}
        id={fieldId}
        type={type}
        {...(error && { error: true, helperText: error })}
      />
    </FormControl>
  );
};

export default AppTextField;
